import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function PostViewer() {
  const { id: paramId } = useParams();
  const location = useLocation();

  // ✅ Extract from both ?id= and /:id
  const queryId = new URLSearchParams(location.search).get("id");
  const postId = paramId || queryId;

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      if (!postId) {
        setLoading(false);
        return;
      }

      try {
        const collections = ["posts", "videos", "localNews"];

let found = null;

for (const col of collections) {
  const ref = doc(db, col, postId);
  const snap = await getDoc(ref);

  if (snap.exists()) {
    found = snap.data();
    break;
  }
}

if (found) setPost(found); else {
          console.log("❌ No such post found");
        }
      } catch (error) {
        console.error("🔥 Error fetching post:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [postId]);

  // 🌀 Loading shimmer
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: "#f9f9f9",
        }}
      >
        <div
          style={{
            width: "70%",
            height: "300px",
            background: "linear-gradient(90deg, #f0f0f0, #e0e0e0, #f0f0f0)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
            borderRadius: "12px",
          }}
        ></div>
        <p style={{ marginTop: "20px", color: "#777" }}>✨ Loading post...</p>
        <style>{`
          @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
        `}</style>
      </div>
    );
  }

  // ⚠️ No post found
  if (!post) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          backgroundColor: "#fafafa",
          textAlign: "center",
          color: "#555",
        }}
      >
        <img
          src="https://i.ibb.co/ZphkGX0T/eyal-logo-new-edited.jpg"
          alt="Eyal Mart"
          style={{ width: "80px", opacity: 0.6, marginBottom: "10px" }}
        />
        <p>⚠️ This post is not available or has expired.</p>
      </div>
    );
  }

  // ✅ Post Display
  return (
    <div
      style={{
        backgroundColor: "#fff",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px 10px",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "15px",
        }}
      >
        <img
          src="https://i.ibb.co/ZphkGX0T/eyal-logo-new-edited.jpg"
          alt="Eyal Mart"
          style={{ width: "40px", borderRadius: "50%" }}
        />
        <h2 style={{ fontSize: "20px", fontWeight: 600, color: "#222" }}>
          {post.userName || "Eyal Mart"}
        </h2>
      </div>

      {/* Image */}
      {post.imageUrl && (
        <img
          src={post.imageUrl}
          alt="Post"
          style={{
            width: "92%",
            maxWidth: "420px",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        />
      )}

{/* Video */}
{post.videoUrl && (
  <video
    src={post.videoUrl}
    controls
    playsInline
    autoPlay
    style={{
      width: "92%",
      maxWidth: "420px",
      borderRadius: "12px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      background: "#000",
    }}
  />
)}


      {/* Caption */}
      <p
        style={{
          marginTop: "15px",
          fontSize: "16px",
          color: "#444",
          lineHeight: "1.5",
          width: "90%",
          maxWidth: "420px",
          textAlign: "center",
        }}
      >
        {post.text || post.caption || "🛍️ Discover more on Eyal Mart!"}
      </p>

      {/* City / footer */}
      <div
        style={{
          marginTop: "15px",
          fontSize: "14px",
          color: "#666",
        }}
      >
        📍 {post.area || "Eyal Mart"}
      </div>

      <div
        style={{
          marginTop: "25px",
          fontSize: "13px",
          color: "#999",
          borderTop: "1px solid #eee",
          paddingTop: "15px",
        }}
      >
        Powered by <b style={{ color: "#0061ff" }}>Eyal Mart</b>
      </div>
    </div>
  );
}
